import { render, staticRenderFns } from "./QuestionTextarea.vue?vue&type=template&id=f2188478&"
import script from "./QuestionTextarea.vue?vue&type=script&lang=js&"
export * from "./QuestionTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports